/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Sensitive_PageInputs */

const en_site_url_error_sensitive_page = /** @type {(inputs: Site_Url_Error_Sensitive_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in, checkout and payment pages cannot be dissected. Enter the site's home page instead.`)
};

const id_site_url_error_sensitive_page = /** @type {(inputs: Site_Url_Error_Sensitive_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman login, checkout, dan pembayaran tidak bisa dibedah. Masukkan halaman utama situsnya.`)
};

/**
* | output |
* | --- |
* | "Sign-in, checkout and payment pages cannot be dissected. Enter the site's home page instead." |
*
* @param {Site_Url_Error_Sensitive_PageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_sensitive_page = /** @type {((inputs?: Site_Url_Error_Sensitive_PageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Sensitive_PageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_sensitive_page(inputs)
	return en_site_url_error_sensitive_page(inputs)
});